<script lang="ts">
  const currentYear = new Date().getFullYear();
</script>

<footer
  class="flex shrink-0 flex-wrap items-center justify-between gap-2 px-6 py-3 text-xs text-gray-600"
>
  <span class="font-medium">TOMRA Connect <span aria-hidden="true">·</span> Service Portal</span>
  <span>&copy; {currentYear} TOMRA Systems ASA</span>
</footer>
